import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const FaqsConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/faqs',
      component: FuseLoadable({
        loader: () => import('./ListaFaqs')
      })
    }
  ]
}
